import { FC, useContext, useEffect } from "react";
import { LayoutMode } from "../../enums/LayoutMode";
import { LayoutModeContext } from "../../contexts/data/LayoutContext";

/**
 * --- Interfaces ---
 */
export interface ISetLayoutModeProps {
    mode: LayoutMode
}

/**
 * --- Set Layout Mode ---
 */
export const SetLayoutMode: FC<ISetLayoutModeProps> = ({
    mode
}) => {
    const {setMode} = useContext(LayoutModeContext);

    useEffect(() => {
        setMode(mode);
    }, [mode]);

    return null;
}